import PropTypes from "prop-types";


export const FilePropType = PropTypes.shape({
    mimetype: PropTypes.string,
    originalname: PropTypes.string,
    path: PropTypes.string,
    size: PropTypes.number
});

export const ClientContactPropType = PropTypes.shape({
    name: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string
});
